import HomeIntroduction from '../components/Blocks/Home/HomeIntroduction.js';
import PresentationPersonnelle	 from '../components/Blocks/Home/PresentationPersonnelle.js';
import HorizontalSeparator from '../components/Utils/HorizontalSeparator.js';
import Fares from '../components/Blocks/Home/Fares.js';
function Home() {
  return (
	<div className="App">
		<header className="App-header">
			<HomeIntroduction/>
			<HorizontalSeparator/>
			<PresentationPersonnelle/>
			<HorizontalSeparator/>
			<Fares/>
		</header>
	</div>
  );
}

export default Home;
